var cards = document.querySelectorAll('.flip-card');

[...cards].forEach((card)=>{
    const buttons = card.querySelectorAll('.btn');
    [...buttons].forEach((button)=>{
        button.addEventListener( 'click', function() {
            card.classList.toggle('is-flipped');
        });
    });
});
